import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';

/**
 * Trava de acesso por módulo.
 * Verifica no backend (cliente-bpo/:id) se o flag mod_* do cliente está liberado.
 * Se estiver 'Não', bloqueia a página — mesmo que o usuário acesse pela URL direta.
 *
 * Uso: <ModuloRoute modulo="mod_saving" element={<SavingCliente />} />
 */
const ModuloRoute = ({ modulo, element }) => {
  const { cliente_id } = useParams();
  const navigate = useNavigate();
  const [estado, setEstado] = useState('carregando'); // carregando | liberado | bloqueado

  useEffect(() => {
    let ativo = true;
    const verificar = async () => {
      try {
        const token = localStorage.getItem('access');
        const resp = await axios.get(
          `${process.env.REACT_APP_API_BASE}/api/cliente-bpo/${cliente_id}/`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (!ativo) return;
        const cliente = resp.data?.cliente;
        // Liberado por padrão; só bloqueia quando o flag vier explicitamente 'Não'
        const bloqueado = !!cliente && cliente[modulo] === 'Não';
        setEstado(bloqueado ? 'bloqueado' : 'liberado');
      } catch (e) {
        // Falha na verificação não deve travar acesso legítimo (ex.: operador interno / rede).
        if (ativo) setEstado('liberado');
      }
    };
    verificar();
    return () => { ativo = false; };
  }, [cliente_id, modulo]);

  if (estado === 'carregando') {
    return (
      <div className="container-fluid mt-5">
        <div className="text-center">
          <div className="spinner-border" style={{ color: '#00205b' }}></div>
          <p className="mt-3 text-muted">Verificando acesso ao módulo...</p>
        </div>
      </div>
    );
  }

  if (estado === 'bloqueado') {
    return (
      <div className="container-fluid mt-5">
        <div className="card border-0 shadow-sm" style={{ maxWidth: '640px', margin: '0 auto' }}>
          <div className="card-body text-center py-5">
            <i className="fas fa-lock fa-3x text-muted mb-3"></i>
            <h4 style={{ color: '#00205b' }}>Módulo não disponível</h4>
            <p className="text-muted mb-4">
              Este módulo não está habilitado para este cliente.
              <br />
              Entre em contato com a Comece Hub para liberar o acesso.
            </p>
            <button
              className="btn"
              style={{ backgroundColor: '#00205b', borderColor: '#00205b', color: '#fff', fontWeight: 600 }}
              onClick={() => navigate('/dashboard-cliente/' + cliente_id)}
            >
              <i className="fas fa-arrow-left me-2"></i>
              Voltar ao painel
            </button>
          </div>
        </div>
      </div>
    );
  }

  return element;
};

export default ModuloRoute;
